@if (docOrSoftware) {
  @if (productListService.seperateDocDetails$|async; as facetData) {
    @if (facetTabIndex==7) {
      @if (facetData?.facets) {
        <section class="inner"
          [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
          (click)="block($event)">
          <div class="list-header">
            <h4>Select Refinements</h4>
            <button type="button" class="close" [attr.aria-label]="close" (click)="close()">
              <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
            </button>
          </div>
          @for (facet of facetData?.facets; track facet) {
            <app-facet-kb #facetRef [facet]="facet" [facetTabName]="facetTabIndex"
              [class.expanded]="isExpanded(facet) | async" [class.collapsed]="isCollapsed(facet) | async" role="group"
          attr.aria-label="{{
             'productFacetNavigation.ariaLabelItemsAvailable'
               | cxTranslate
                 : {
                     name: facet.name,
                     count: facet?.values?.length
                   }
           }}"></app-facet-kb>
        }
      </section>
    }
  }
}
<!-- <ng-container *ngIf="productListService.seperateSoftDetails$|async as facetData">
<ng-container *ngIf="facetTabIndex==8">
  <section class="inner" *ngIf="facetData?.facets"
    [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
    (click)="block($event)">
    <div class="list-header">
      <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
      <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
        <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
      </button>
    </div>
    <app-facet-kb *ngFor="let facet of facetData?.facets" #facetRef [facet]="facet" [facetTabName]="facetTabIndex"
      [class.expanded]="isExpanded(facet) | async" [class.collapsed]="isCollapsed(facet) | async" role="group"
          attr.aria-label="{{
         'productFacetNavigation.ariaLabelItemsAvailable'
           | cxTranslate
             : {
                 name: facet.name,
                 count: facet?.values?.length
               }
       }}"></app-facet-kb>
</section>
</ng-container>
</ng-container> -->
} @else {
  <!-- <ng-container *ngIf="productListService.countDetails$|async as facetData">
  <ng-container *ngIf="facetTabIndex==0">
    <section class="inner" *ngIf="facetData?.productModel?.facets"
      [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
      (click)="block($event)">
      <div class="list-header">
        <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
        <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
          <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div> -->
      <!--
      Here we'd like to introduce configurable facet components,
      either by using specific configuration or generic sproutlets
      -->
      <!-- <app-facet-kb *ngFor="let facet of facetData?.productModel?.facets" #facetRef [facet]="facet"
      [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
  [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
      'productFacetNavigation.ariaLabelItemsAvailable'
        | cxTranslate
          : {
              name: facet.name,
              count: facet?.values?.length
            }
    }}"></app-facet-kb>
</section>
</ng-container>
<ng-container *ngIf="facetTabIndex==1">
  <section class="inner" *ngIf="facetData?.crossRefModel?.facets"
    [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1" (click)="block($event)">
    <div class="list-header">
      <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
      <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
        <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
      </button>
    </div>
    -->
    <!--
    Here we'd like to introduce configurable facet components,
    either by using specific configuration or generic sproutlets
    -->
    <!--  <app-facet-kb *ngFor="let facet of facetData?.crossRefModel?.facets" #facetRef [facet]="facet"
    [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
      [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
       'productFacetNavigation.ariaLabelItemsAvailable'
         | cxTranslate
           : {
               name: facet.name,
               count: facet?.values?.length
             }
     }}"></app-facet-kb>
</section>
</ng-container>
<ng-container *ngIf="facetTabIndex==2">
  <section class="inner" *ngIf="facetData?.docModel?.facets"
    [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1" (click)="block($event)">
    <div class="list-header">
      <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
      <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
        <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
      </button>
    </div>
    -->
    <!--
    Here we'd like to introduce configurable facet components,
    either by using specific configuration or generic sproutlets
    -->
    <!-- <app-facet-kb *ngFor="let facet of facetData?.docModel?.facets" #facetRef [facet]="facet"
    [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
      [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
       'productFacetNavigation.ariaLabelItemsAvailable'
         | cxTranslate
           : {
               name: facet.name,
               count: facet?.values?.length
             }
     }}"></app-facet-kb>
</section>
</ng-container>
<ng-container *ngIf="facetTabIndex==3">
  <section class="inner" *ngIf="facetData?.softwareModel?.facets"
    [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1" (click)="block($event)">
    <div class="list-header">
      <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
      <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
        <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
      </button>
    </div>
    -->
    <!--
    Here we'd like to introduce configurable facet components,
    either by using specific configuration or generic sproutlets
    -->
    <!-- <app-facet-kb *ngFor="let facet of facetData?.softwareModel?.facets" #facetRef [facet]="facet"
    [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
      [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
       'productFacetNavigation.ariaLabelItemsAvailable'
         | cxTranslate
           : {
               name: facet.name,
               count: facet?.values?.length
             }
     }}"></app-facet-kb>
</section>
</ng-container>
<ng-container *ngIf="facetTabIndex==4">
  <section class="inner" *ngIf="facetData?.trainingModel?.facets"
    [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1" (click)="block($event)">
    <div class="list-header">
      <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
      <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
        <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
      </button>
    </div> -->
    <!--
    Here we'd like to introduce configurable facet components,
    either by using specific configuration or generic sproutlets
    -->
    <!--  <app-facet-kb *ngFor="let facet of facetData?.trainingModel?.facets" #facetRef [facet]="facet"
    [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
      [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
       'productFacetNavigation.ariaLabelItemsAvailable'
         | cxTranslate
           : {
               name: facet.name,
               count: facet?.values?.length
             }
     }}"></app-facet-kb>
</section>
</ng-container>
</ng-container>
-->
}
